import BuyerWelcomeVideo from './BuyerWelcomeVideo'

export default BuyerWelcomeVideo
